export default {
  app: {
    place: {
      address: 'Address',
      showOnExternalMaps: 'Show on Google Maps',
    },
  },
};
